import store from '@/store'
import actions from '@/store/actions'
import mutations from '@/store/mutations'

export const getAllEmployers = async () => {
  const employers = await store.dispatch(actions.callApi, { url: 'employers' })
  store.commit(mutations.SET_EMPLOYERS, employers)
}

export const saveEmployer = async (data) => {
  const employer = await store.dispatch(
    actions.callApi,
    {
      url: data.id ? `employers/${data.id}` : 'employers',
      method: data.id ? 'put' : 'post',
      body: {
        ...data,
        address: undefined
      }
    }
  )
  !data.id && store.commit(mutations.ADD_EMPLOYER, employer)
  store.dispatch(actions.createMessage, { text: 'Employer saved', color: 'success' })
  return employer
}

export const deleteEmployer = async (id) => {
  await store.dispatch(
    actions.callApi,
    {
      url: `employers/${id}`,
      method: 'delete'
    }
  )
  store.dispatch(actions.createMessage, { text: 'Employer saved', color: 'success' })
}
